import { useState } from 'react';
import { IconDotsVertical, IconLogout, IconUserCircle } from '@tabler/icons-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';
import { useUserStore } from '@/stores/userStore';
import { UserInfoDialog } from './UserInfoDialog';
import { useNavigate } from 'react-router-dom';

export function NavUser() {
  const { isMobile } = useSidebar();
  const { userInfo, clearUser } = useUserStore();
  const [openUserInfoDialog, setOpenUserInfoDialog] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    clearUser();
    navigate('/login', { replace: true });
  };

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground gap-2.5 px-5"
            >
              <Avatar className="h-7 w-7 rounded-sm">
                <AvatarImage
                  src={userInfo?.avatarUrl}
                  alt={userInfo?.nickname || userInfo?.username || userInfo?.email}
                />
                <AvatarFallback className="bg-blue-600 rounded-sm text-white text-base">
                  {userInfo?.email?.slice(0, 1)?.toLocaleUpperCase()}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight mr-4.5 group-data-[collapsible=compact]:hidden">
                <span className="truncate font-medium">
                  {userInfo?.nickname || userInfo?.username || userInfo?.email}
                </span>
                <span className="text-muted-foreground truncate text-xs">{userInfo?.email}</span>
              </div>
              <IconDotsVertical className="ml-auto size-4 group-data-[collapsible=compact]:hidden" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
            side={isMobile ? 'bottom' : 'right'}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-5 py-4 text-left text-sm">
                <Avatar className="h-8 w-8 rounded-lg">
                  <AvatarImage
                    src={userInfo?.avatarUrl}
                    alt={userInfo?.nickname || userInfo?.username || userInfo?.email}
                  />
                  <AvatarFallback className="rounded-lg">
                    {userInfo?.email?.slice(0, 2)?.toLocaleUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">
                    {userInfo?.nickname || userInfo?.username || userInfo?.email}
                  </span>
                  <span className="text-muted-foreground truncate text-xs">{userInfo?.email}</span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={() => setOpenUserInfoDialog(true)}>
                <IconUserCircle />
                个人信息
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout}>
              <IconLogout />
              退出账号
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
      <UserInfoDialog open={openUserInfoDialog} onOpenChange={setOpenUserInfoDialog} />
    </SidebarMenu>
  );
}
